import { kAdminUser, enumFolderStatus } from "../constants";
import { IsTrashFolder } from "./IsTrashFolder";
import { IsHiddenFolder } from "./IsHiddenFolder";
import { CheckIfPrivate } from "./CheckIfPrivate";
import { AddFolderToList } from "./AddFolderToList";
import { Globals } from "../CoreApp/Globals";

export function ApplyAccessGroup(wsMgr, accessGroupMgr, dirList, includeTrash, includeLocked) {
  var finalList = dirList;
  var n = finalList.length;
  var folderList = [];
  var curGroupID = wsMgr.GetUserGroupID();
  var curGroup = null;
  var groupExists = true;

  var ut = Globals._accountInfo.GetUserRole();
  var isAdmin = ut === kAdminUser;

  if (!isAdmin && curGroupID != "0") {
    curGroup = accessGroupMgr.GetGroupByID(curGroupID);
    groupExists = curGroup != null;
  }
  var curUser = "[" + wsMgr.GetUserName().toLowerCase() + "]";
  if (groupExists) {
    for (var i = 0; i < n; i++) {
      var folderName = finalList[i];
      var groupStatus = enumFolderStatus.ingroup;
      if (curGroup) {
        groupStatus = curGroup.FolderInGroup(folderName);
        if (!includeLocked && groupStatus === enumFolderStatus.ingrouplocked)
          groupStatus = enumFolderStatus.notingroup;
      }

      var isCurrentPrivateFolder = folderName.toLowerCase() === curUser;
      if (
        isAdmin ||
        curGroupID == "0" ||
        groupStatus !== enumFolderStatus.notingroup ||
        isCurrentPrivateFolder
      ) {
        var isTrash = false;
        if (!includeTrash) isTrash = IsTrashFolder(folderName);

        var includeFolder = !IsHiddenFolder(folderName) && !isTrash;
        if (includeFolder) {
          var showPrivateFolder = false;
          if (!isCurrentPrivateFolder && !isAdmin)
            showPrivateFolder = CheckIfPrivate(folderName, curGroup, groupStatus);

          if (!showPrivateFolder) AddFolderToList(folderName, groupStatus, folderList);
        }
      }
    }
  }

  return folderList;
}
